// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerTableHandleRowMenuRootElement, type TableHandleRowMenuRootElement, type TableHandleRowMenuRootProps as TableHandleRowMenuRootElementProps } from '@prosekit/web/table-handle';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes, useLayoutEffect } from 'react';

/** Props for the {@link TableHandleRowMenuRoot} React component. */
export interface TableHandleRowMenuRootProps {
  /**
   * Whether the overlay is initially open.
   * @default false
   */
  defaultOpen?: TableHandleRowMenuRootElementProps['defaultOpen'];
  /**
   * Whether the overlay is currently open.
   * @default null
   */
  open?: TableHandleRowMenuRootElementProps['open'];
  /**
   * Whether the component should ignore user interaction.
   * @default false
   */
  disabled?: TableHandleRowMenuRootElementProps['disabled'];
}

function TableHandleRowMenuRootComponent(props: TableHandleRowMenuRootProps, forwardedRef: ForwardedRef<TableHandleRowMenuRootElement>) {
  registerTableHandleRowMenuRootElement();

  const elementRef = useRef<TableHandleRowMenuRootElement>(null);

  const { defaultOpen: p0, disabled: p1, open: p2, ...restProps } = props;

  useLayoutEffect(() => {
    const element = elementRef.current as Record<string, unknown> | null;
    if (!element) return;
    Object.assign(element, { defaultOpen: p0, disabled: p1, open: p2 });
  });

  const mergedRef = useCallback(
    (element: TableHandleRowMenuRootElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-table-handle-row-menu-root', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-table-handle-row-menu-root` custom element. */
export const TableHandleRowMenuRoot: ForwardRefExoticComponent<TableHandleRowMenuRootProps & HTMLAttributes<TableHandleRowMenuRootElement> & RefAttributes<TableHandleRowMenuRootElement>> = /* @__PURE__ */ forwardRef(TableHandleRowMenuRootComponent);
